<template>
  <div style="width: 450px">
    <template v-if="loading">
      <small>Informações sobre o estatuto</small>
      <br>
      Carregando...
    </template>
    <template v-else>
      <div v-if="!document" class="">
        <small>Turma com Estatuto?</small>
        <br>
        {{ document ? 'SIM' : 'NÃO' }}
      </div>
      <div v-else class="">
        <small>Status do estatuto</small>
        <br>
        <v-chip small :color="statusColor">{{ status || 'Carregando...' }}</v-chip>
      </div>
      <div v-if="signedIn" class="">
        <small>Assinado em</small>
        <br>
        {{ signedIn | moment('DD/MM/YYYY') }}
      </div>
      <div v-else-if="link" class="">
        <small>Link de assinatura</small>
        <br>
        <a :href="link" target="_blank">{{ link }}</a>
      </div>
      <div v-else-if="documentLink" class="">
        <small>Link do estatuto</small>
        <br>
        <a :href="documentLink" target="_blank">{{ documentLink }}</a>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'participantDocumentStatus',
  props: ['celebrationId', 'email', 'participantId'],
  data: () => ({
    loading: false,
    document: null,
    status: '',
    statusColor: 'mute',
    signedIn: '',
    link: ''
  }),
  computed: {
    documentLink () {
      if (this.document) {
        return `https://painel.autentique.com.br/documentos/${this.document}`
      }
      return ''
    }
  },
  methods: {
    getData () {
      this.loading = true
      this.$firestore.collection('settings').doc(this.celebrationId).get()
        .then((snapshot) => {
          const data = snapshot.data()
          this.document = (data && data.document) || null
          const exceptionalSignatures = (data && data.signatures) || {}
          const exceptionalEmail = exceptionalSignatures[this.participantId] || ''

          if (this.document) {
            this.$store.dispatch('firebaseApi', `autentiquedoc?documentId=${this.document}`)
              .then(async response => {
                if (response.signatures) {
                  const matchSign = response.signatures.find(s => s.email === this.email || s.email === exceptionalEmail)
                  if (matchSign) {
                    if (matchSign.signed) this.status = 'Assinado'
                    else if (matchSign.viewed) this.status = 'Visualizado'
                    else if (matchSign.email_events && matchSign.email_events.opened) this.status = 'Email aberto'
                    else if (matchSign.email_events && matchSign.email_events.delivered) this.status = 'Email entregue'
                    else if (matchSign.email_events && matchSign.email_events.refused) this.status = 'Email com erro'

                    if (matchSign.signed) this.statusColor = 'success'
                    else if (matchSign.email_events && matchSign.email_events.refused) this.statusColor = 'error'
                    else this.statusColor = 'warning'

                    this.signedIn = matchSign.signed ? matchSign.signed.created_at : ''
                    this.link = matchSign.link || ''
                  } else if (data.alternativeDocuments && data.alternativeDocuments.length > 0) {
                    for (const index in data.alternativeDocuments) {
                      const documentId = data.alternativeDocuments[index]
                      await this.$store.dispatch('firebaseApi', `autentiquedoc?documentId=${documentId}`)
                        .then(resp => {
                          if (resp.signatures) {
                            const matchSign = resp.signatures.find(s => s.email === this.email || s.email === exceptionalEmail)
                            if (matchSign) {
                              if (matchSign.signed) this.status = 'Assinado'
                              else if (matchSign.viewed) this.status = 'Visualizado'
                              else if (matchSign.email_events && matchSign.email_events.opened) this.status = 'Email aberto'
                              else if (matchSign.email_events && matchSign.email_events.delivered) this.status = 'Email entregue'
                              else if (matchSign.email_events && matchSign.email_events.refused) this.status = 'Email com erro'

                              if (matchSign.signed) this.statusColor = 'success'
                              else if (matchSign.email_events && matchSign.email_events.refused) this.statusColor = 'error'
                              else this.statusColor = 'warning'

                              this.signedIn = matchSign.signed ? matchSign.signed.created_at : ''
                              this.link = matchSign.link || ''
                            }
                          }
                        })

                      if (!this.status) {
                        this.status = 'Não enviado'
                        this.statusColor = 'error'
                        this.signedIn = ''
                        this.link = ''
                      }
                    }
                  } else {
                    this.status = 'Não enviado'
                    this.statusColor = 'error'
                    this.signedIn = ''
                    this.link = ''
                  }
                }
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.loading = false
          }
        })
        .catch(() => {
          this.SET_SNACKBAR({ text: 'Não foi possivel trazer as configurações, tente novamente' })
          this.loading = false
        })
    }
  },
  created () {
    this.getData()
  }
}
</script>
